module.exports = __webpack_public_path__ + "img/17.3e8439ee.jpg";